import type { FaireProductEntity } from "../../entity_types/product";

export const p_dtgkja38j7: FaireProductEntity = {
  token: "p_dtgkja38j7",
  type: "product",
  name: "Summit Smolder | Powdered Hot Sauce for Backpacking (Medium)",
  brandToken: "b_z7rsufrbjc",
  brandName: "Wildfire Spice Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/3853e56dd50f9c91896e817008b7079603b00183cbdc8119fdacd961ddba5f97.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5cfcaf570b57519e9cc053f6a1244939aa7e0e233dd49a5758281b045da89ca2.png",
  ],
  priceDollars: 3,
  description:
    "Intermediate Heat | Delicious Scotch Bonnet Pepper \n\nMeet Summit Smolder — slow burn with a tasty depth. \n\nBuilt around Scotch bonnet peppers, this blend delivers layered warmth without overwhelming your meal. Savory garlic, subtle tang, and a steady burn that keeps you coming back for more.\n\nIt’s the one you reach for when you want amazing flavor & perfect heat. Not too much, not too little. Packed with flavor to end your 20-mile day perfectly. \n\nIngredients\n\nVinegar powder, scotch bonnet pepper, garlic, onion, salt, Worcestershire powder (maltodextrin, distilled vinegar, molasses, corn syrup, salt, caramel color, garlic powder, sugar, spices, celery seed, tamarind, natural flavor). \n",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:11.697Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
